function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H32V32H0z",
  transform: "translate(-1118 -80) translate(0 64) translate(1118 16)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 .8h-1.6c0-.442-.358-.8-.8-.8H3.2c-.442 0-.8.358-.8.8H.8c-.442 0-.8.358-.8.8v13.6c0 .442.358.8.8.8H12c.442 0 .8-.358.8-.8V1.6c0-.442-.358-.8-.8-.8zm-.8 13.6H1.6v-12h.8c0 .442.358.8.8.8h6.4c.442 0 .8-.358.8-.8h.8v12z",
  transform: "translate(-1118 -80) translate(0 64) translate(1118 16) translate(10 8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.232 6.632L5.6 9.272l-1.032-1.04c-.317-.272-.79-.254-1.086.042-.296.295-.314.769-.042 1.086l1.6 1.6c.312.31.816.31 1.128 0l3.2-3.2c.272-.317.254-.79-.042-1.086-.295-.296-.769-.314-1.086-.042h-.008z",
  transform: "translate(-1118 -80) translate(0 64) translate(1118 16) translate(10 8)"
}))))));

var SvgTasks = function SvgTasks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTasks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tasks.09120058.svg";
export { ForwardRef as ReactComponent };